import { createContext, useContext, type ReactNode } from 'react';

/** One entry's moves, for a menu that offers them instead of the buttons. */
export interface SortableMoves {
  moveUp: () => void;
  moveDown: () => void;
  canMoveUp: boolean;
  canMoveDown: boolean;
}

/** The finished handle of the `SortableItem` a `SortableHandle` sits in, and its moves. */
export const ItemContext = createContext<{
  handle: ReactNode;
  moves: SortableMoves;
} | null>(null);

/**
 * Move up and Move down for the `SortableItem` this sits in, for a menu that
 * offers them in place of the handle's buttons. Each move is announced, as
 * the buttons' are.
 */
export function useSortableMoves(): SortableMoves {
  const item = useContext(ItemContext);
  if (!item) throw new Error('useSortableMoves must be used inside a SortableItem.');
  return item.moves;
}
